import React, { useState } from 'react';
import { MdOutlineTextSnippet } from 'react-icons/md';
import { BsPlusLg } from 'react-icons/bs';
import { CgClose } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';

const TermsAndCondition = () => {
    const [isActive, setIsActive] = useState(false);
    const navigate = useNavigate();

    return (
        <div>
            <div className='tAndcContainer'>
                <div className="accordion-title d-flex justify-content-between align-items-center" onClick={() => setIsActive(!isActive)}>
                    
                        <div className='faq-container'>
                            <div className='terms-icon-container'>
                                <MdOutlineTextSnippet className='terms-icon' size={20} color="#FFFFFF" />
                            </div>
                            <span className='termsTitle'>Terms & Conditions</span>
                        </div>
                    <div className="col-1 d-flex justify-content-end"><span className="row toggleBtn">{isActive ? <CgClose size={22} /> : <BsPlusLg />}</span></div>
                </div>
                {isActive && <div className="accordion-content subText">
                    <div>
                        <ul className='termAndConditionPoints mt-4'>
                            <li style={{color: '#FFFFFF'}}>
                                <p>DURATION OF THE CONTEST<br />
                                The Contest Period shall be from 22nd March, 2025 6:30PM to 25th May, 2025 11:59PM.<a style={{ color: '#D1964A' }} onClick={() => { navigate('/TermsAndCondition') }} className='tAndc'>read more.</a></p>
                            </li>
                        </ul>
                    </div>
                </div>}
            </div>
        </div>
    );
}

export default TermsAndCondition;


